import type { MenuOptions } from "@circleco/compass/components/Menu";

import { conversationActionsCopy } from "../conversationActionsCopy";
import { ConversationCardMenu } from "./ConversationCardMenu";
import { useCopyCircleAiLink } from "./useCopyCircleAiLink";

export const NewConversationActionsMenu = () => {
  const copyLink = useCopyCircleAiLink();

  const options: MenuOptions = [
    {
      icon: "chain-link",
      label: conversationActionsCopy().copyLink.menuLabel,
      onClick: () => copyLink(null),
    },
  ];

  return <ConversationCardMenu options={options} />;
};
